var _circle, _path, _circle2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpportunity(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 7,
    fill: "#13C1BF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.625 8.25H22.75C22.5312 8.25 22.375 8.4375 22.375 8.65625L22.4375 11.7188C21.0625 9.65625 18.6875 8.25 16 8.25C12.1875 8.25 9.03125 10.9688 8.375 14.5625C8.3125 14.8125 8.5 15 8.75 15H9.625C9.8125 15 9.96875 14.9062 10 14.7188C10.5938 11.9688 13.0312 9.875 16 9.875C18.4688 9.875 20.5938 11.375 21.5625 13.5L17.625 13.4062C17.4062 13.4062 17.25 13.5625 17.25 13.7812V14.625C17.25 14.8438 17.4062 15 17.625 15H23.625C23.8125 15 24 14.8438 24 14.625V8.625C24 8.4375 23.8125 8.25 23.625 8.25ZM23.2188 17H22.3438C22.1562 17 22 17.125 21.9688 17.3125C21.375 20.0625 18.9375 22.125 16 22.125C13.5 22.125 11.375 20.6562 10.4062 18.5312L14.3438 18.625C14.5625 18.625 14.75 18.4688 14.75 18.25V17.375C14.75 17.1875 14.5625 17 14.375 17H8.375C8.15625 17 8 17.1875 8 17.375V23.375C8 23.5938 8.15625 23.75 8.375 23.75H9.21875C9.4375 23.75 9.59375 23.5938 9.59375 23.375L9.53125 20.3125C10.9062 22.375 13.2812 23.75 16 23.75C19.7812 23.75 22.9375 21.0625 23.5938 17.4688C23.6562 17.2188 23.4688 17 23.2188 17Z",
    fill: "#36424E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    stroke: "#36424E",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpportunity);
export default __webpack_public_path__ + "static/media/opportunity.e46dda29465c3d711198cd690b83ae6d.svg";
export { ForwardRef as ReactComponent };